import { React, useEffect, useRef, useState, useCallback } from 'react'
// import Select from "react-dropdown-select";
import './search.css'
import NameBox from '../../core/NameBox';

function Search({ allNames }) {



  const lagerRef = useRef();
  const [lagerList, setLagerList] = useState([]);
  const [resetClicked, setResetClicked] = useState(false);

  const [landList, setLandList] = useState([]);

  const [numOfresults, setNumOfresults] = useState();



  const [lagerInputValue, setLagerInputValue] = useState('');

  const [nameInputValue, setNameInputValue] = useState('');

  const [surNameInputValue, setSurNameInputValue] = useState('');
  const [landInputValue, setLandInputValue] = useState('');
  const [birthYearFromInputValue, setBirthYearFromInputValue] = useState('');
  const [birthYearTillInputValue, setBirthYearTillInputValue] = useState('');
  const [labourYearFromInputValue, setLabourYearFromInputValue] = useState('');
  const [labourYearTillInputValue, setLabourYearTillInputValue] = useState('');


  const [filteredAllNames, setFilteredAllNames] = useState(allNames);

  const [listOfNames, setListOfNames] = useState([]);
  const [listOfSurnames, setListOfSurnames] = useState([]);
  const [listOfbirthYearsFrom, setListOfbirthYearsFrom] = useState([]);
  const [listOfbirthYearsTill, setListOfbirthYearsTill] = useState([]);
  const [listOfLabourYearsFrom, setListOfLabourYearsFrom] = useState([]);
  const [listOfLabourYearsTill, setListOfLabourYearsTill] = useState([]);













  const [showBirthYearFromSuggestions, setShowBirthYearFromSuggestions] = useState(false);
  const [showBirthYearTillSuggestions, setShowBirthYearTillSuggestions] = useState(false);
  const [showLabourYearFromSuggestions, setShowLabourYearFromSuggestions] = useState(false);
  const [showLabourYearTillSuggestions, setShowLabourYearTillSuggestions] = useState(false);


  // State to hold filtered suggestions
  const [landFilteredSuggestions, setLandFilteredSuggestions] = useState([]);
  // State to control visibility of suggestions
  const [showLandSuggestions, setShowLandSuggestions] = useState(false);

  // State to hold the filtered suggestions
  const [LagerfilteredSuggestions, setLagerFilteredSuggestions] = useState([]);
  // State to control the visibility of suggestions
  const [showLagerSuggestions, setShowLagerSuggestions] = useState(false);


  const [nameFilteredSuggestions, setNameFilteredSuggestions] = useState([]);
  const [showNameSuggestions, setShowNameSuggestions] = useState(false);

  const [surnameFilteredSuggestions, setSurnameFilteredSuggestions] = useState([]);
  const [showSurnameSuggestions, setShowSurnameSuggestions] = useState(false);


  const getNumOfresults = useCallback(() => {
    return filteredAllNames.length

  }, [filteredAllNames])


  const getFilteredAllNames = useCallback(() => {
    return filteredAllNames
  }, [filteredAllNames])




  // Handle suggestion click

  const handleLagerInputOnChange = (e) => {

    const value = e.target.value;
    setLagerInputValue(value)
    const filtered = makeLagerSuggestionsList().filter((suggestion) =>
      suggestion.toLowerCase().startsWith(value.toLowerCase())
    );

    setLagerFilteredSuggestions(filtered);
    setShowLagerSuggestions(true);

  }

  const handleLagerInputFocus = () => {

    setLagerFilteredSuggestions(makeLagerSuggestionsList());
    setShowLagerSuggestions(true);

    // // console.log(e.target.name);


    // if (e.target.name === 'lager') {
    //   setLagerFilteredSuggestions(lagerList);
    //   setShowLagerSuggestions(true);





    // }






  };

  // Handle suggestion click
  const handleLagerSuggestionClick = (suggestion) => {
    setLagerInputValue(suggestion);
    setShowLagerSuggestions(false); // Hide suggestions after selection


    let tempAllNames = [];

    filteredAllNames.map((person => {
      if (person.Modified_Lager) {
        // console.log(person);

        if (Array.isArray(person.Modified_Lager)) {
          // console.log(person);

          person.Modified_Lager.map((lager) => {
            if (lager === suggestion) {
              tempAllNames.push(person)
            }
          })
        }
        else {
          if (person.Modified_Lager === suggestion) {
            tempAllNames.push(person);
          }
        }
      }
      else {
        tempAllNames.push(person);
      }
    }))

    const uniqueArray = [...new Set(tempAllNames)];

    setFilteredAllNames(uniqueArray);
    setNumOfresults(filteredAllNames.length);


  };

  const handleLandSuggestionClick = (suggestion) => {
    setLandInputValue(suggestion);
    setShowLandSuggestions(false); // Hide suggestions after selection


    let tempAllNames = [];

    filteredAllNames.map((person => {
      if (person.Modified_Staat) {
        if (Array.isArray(person.Modified_Staat)) {
          person.Modified_Staat.map((staat) => {
            if (staat === suggestion) {
              tempAllNames.push(person)
            }
          })
        }
        else {
          if (person.Modified_Staat === suggestion) {
            tempAllNames.push(person);
          }
        }
      }
      else {
        tempAllNames.push(person);
      }
    }))

    const uniqueArray = [...new Set(tempAllNames)];

    setFilteredAllNames(uniqueArray);
    setNumOfresults(filteredAllNames.length);



  };


  // Handle input change
  const handleLandInputChange = (e) => {
    const value = e.target.value;
    setLandInputValue(value);

    // Filter the suggestions to show only those that start with the input value
    // if (value) {
    const filtered = makeLandSuggestionsList().filter((suggestion) =>
      suggestion.toLowerCase().startsWith(value.toLowerCase())
    );
    setLandFilteredSuggestions(filtered);
    setShowLandSuggestions(true);
    // } 


    // else {
    // Hide suggestions if input is cleared
    // setShowLandSuggestions(false);
    // }
  }


  const handleLandOnFocus = () => {
    setLandFilteredSuggestions(makeLandSuggestionsList());
    setShowLandSuggestions(true);
  }
  const handleLandOnBlur = () => {

    setTimeout(() => setShowLandSuggestions(false), 200);

  }





  // Handler for outside click
  const handleClick = (event) => {

    // console.log(event.target);


    // if (lagerRef.current.contains(event.target)) {
    //   // handleLagerSuggestionClick(event.target.value);
    //   // console.log(event.tag.value);


    // }



    if (event.key === 'Escape') {
      setShowLagerSuggestions(false);

      // lagerRef.current.blur();
    }



  };

  // const debounceHandleLandOnBlur = debounce(handleLandOnBlur,200)

  const handleLagerOnBlur = () => {

    setTimeout(() => setShowLagerSuggestions(false), 200);






  }

  const handleNameInputOnChange = (e) => {
    // console.log(listOfNames);

    const value = e.target.value;
    setNameInputValue(value);
    if (!surNameInputValue && !landInputValue && !birthYearFromInputValue && !birthYearTillInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    const filtered = makeNameSuggestionsList().filter((suggestion) =>
      suggestion.toLowerCase().startsWith(value.toLowerCase()));

    setNameFilteredSuggestions(filtered);
    setShowNameSuggestions(true);


  }

  const handleNameSuggestionClick = (suggestion) => {
    setNameInputValue(suggestion);
    setShowNameSuggestions(false);

    let tempAllNames = [];

    filteredAllNames.map((person) => {
      if (person.Vorname == suggestion) {

        // console.log(person);
        tempAllNames.push(person);


      }

      if (person.Modified_Namen_andere_version != '') {
        if (Array.isArray(person.Modified_Namen_andere_version)) {
          person.Modified_Namen_andere_version.map((namversion) => {
            if (namversion == suggestion) {
              tempAllNames.push(person)
            }
          })
        }

        else {
          if (person.Modified_Namen_andere_version === suggestion) {
            tempAllNames.push(person);
          }
        }

      }

    })
    const uniqueArray = [...new Set(tempAllNames)];
    setFilteredAllNames(uniqueArray);
    setNumOfresults(filteredAllNames.length)

  }




  const handleNameInputOnFocus = () => {
    setNameFilteredSuggestions(makeNameSuggestionsList());
    setShowNameSuggestions(true);


  }


  const handleNameInputOnBlur = () => {

    setTimeout(() => setShowNameSuggestions(false), 200);
  }


  const handleSurNameInputOnChange = (e) => {
    const value = e.target.value;
    setSurNameInputValue(value);

    if (!nameInputValue && !landInputValue && !birthYearFromInputValue && !birthYearTillInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    const filtered = makeSurnameSuggestionsList().filter((suggestion) =>
      suggestion.toLowerCase().startsWith(value.toLowerCase()));

    setSurnameFilteredSuggestions(filtered);
    setShowSurnameSuggestions(true);
  }

  const handlesurnameSuggestionClick = (suggestion) => {

    setSurNameInputValue(suggestion);
    // console.log(suggestion);

    setShowSurnameSuggestions(false);

    let tempAllNames = [];

    filteredAllNames.map((person) => {
      if (person.Nachname == suggestion) {

        // console.log(person);
        tempAllNames.push(person);


      }

      if (person.Modified_Namen_andere_version != '') {
        if (Array.isArray(person.Modified_Namen_andere_version)) {
          person.Modified_Namen_andere_version.map((namversion) => {
            if (namversion == suggestion) {
              tempAllNames.push(person)
            }
          })
        }

        else {
          if (person.Modified_Namen_andere_version == suggestion) {
            tempAllNames.push(person);
          }
        }

      }

    })
    const uniqueArray = [...new Set(tempAllNames)];
    setFilteredAllNames(uniqueArray);
    setNumOfresults(filteredAllNames.length)

  }

  const handleSurnameInputOnFocus = () => {
    if (surNameInputValue === '') {


      setSurnameFilteredSuggestions(makeSurnameSuggestionsList());
      setShowSurnameSuggestions(true);
    }
  }

  const handleSurnameInputOnBlur = () => {

    setTimeout(() => {

      setShowSurnameSuggestions(false)
    }, 200);

  }

  const handleBirthYearFromInputOnChange = (e) => {

    const value = e.target.value;
    setBirthYearFromInputValue(value);
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearTillInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    // const filtered = makeBirthYearFromSuggestionsList().filter((suggestion) =>
    //   suggestion.startsWith(value));

    setListOfbirthYearsFrom(makeBirthYearFromSuggestionsList());
    setShowBirthYearFromSuggestions(true);

  }

  const handleBirthYearFromInputOnFocus = () => {
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearTillInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);

    }
    setListOfbirthYearsFrom(makeBirthYearFromSuggestionsList());

    setShowBirthYearFromSuggestions(true);

    // console.log(listOfbirthYearsFrom.length);



  }

  const handleBirthYearFromInputOnBlur = () => {
    setTimeout(() => {
      setShowBirthYearFromSuggestions(false)
    }, 200);

  }


  const handleBirthYearFromInputOnSuggestionClick = (suggestion) => {
    setBirthYearFromInputValue(suggestion);
    setShowBirthYearFromSuggestions(false);

    let tempAllNames = [];

    filteredAllNames.map((person) => {
      if (person.Geburts_Jahr) {
        // console.log(person.Geburts_Jahr);

        if (Array.isArray(person.Geburts_Jahr)) {
          person.Geburts_Jahr.map((year) => {
            // console.log(year);

            if (year >= suggestion) {
              tempAllNames.push(person);
              // console.log(year);

            }
          })
        }

        else {
          if (person.Geburts_Jahr >= suggestion) {
            tempAllNames.push(person)
            // console.log(person.Geburts_Jahr);

          }
        }

        // console.log(person);
        // tempAllNames.push(person);


      }
      else {
        tempAllNames.push(person);
        // console.log(person.Geburts_Jahr);

      }




    })
    // console.log(tempAllNames);
    const uniqueArray = [...new Set(tempAllNames)];
    // console.log(uniqueArray.length);

    // console.log(uniqueArray);

    setFilteredAllNames(uniqueArray);
    setNumOfresults(filteredAllNames.length)

  }

  const handleBirthYearTillInputOnChange = (e) => {
    const value = e.target.value;
    setBirthYearTillInputValue(value);
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearFromInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    // const filtered = makeBirthYearFromSuggestionsList().filter((suggestion) =>
    //   suggestion.startsWith(value));

    setListOfbirthYearsTill(makeBirthYearTillSuggestionsList());
    setShowBirthYearTillSuggestions(true);
  }

  const handleBirthYearTillInputOnFocus = () => {
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearFromInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);

    }
    setListOfbirthYearsTill(makeBirthYearTillSuggestionsList());

    setShowBirthYearTillSuggestions(true);

    // console.log(listOfbirthYearsFrom.length);
  }

  const handleBirthYearTillInputOnBlur = () => {
    setTimeout(() => {
      setShowBirthYearTillSuggestions(false)
    }, 200);

  }

  const handleBirthYearTillInputOnSuggestionClick = (suggestion) => {
    setBirthYearTillInputValue(suggestion);
    setShowBirthYearTillSuggestions(false);

    let tempAllNames = [];

    filteredAllNames.map((person) => {
      if (person.Geburts_Jahr) {
        // console.log(person.Geburts_Jahr);

        if (Array.isArray(person.Geburts_Jahr)) {
          person.Geburts_Jahr.map((year) => {
            // console.log(year);

            if (year <= suggestion) {
              tempAllNames.push(person);
              // console.log(year);

            }
          })
        }

        else {
          if (person.Geburts_Jahr <= suggestion) {
            tempAllNames.push(person)
            // console.log(person.Geburts_Jahr);

          }
        }

        // console.log(person);
        // tempAllNames.push(person);


      }
      else {
        tempAllNames.push(person);
        // console.log(person.Geburts_Jahr);

      }




    })
    // console.log(tempAllNames);
    const uniqueArray = [...new Set(tempAllNames)];
    // console.log(uniqueArray.length);

    // console.log(uniqueArray);

    setFilteredAllNames(uniqueArray);
    setNumOfresults(filteredAllNames.length)

  }

  const handleLabourYearFromInputOnChange = (e) => {
    const value = e.target.value;
    setLabourYearFromInputValue(value);
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearTillInputValue && !birthYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    // const filtered = makeBirthYearFromSuggestionsList().filter((suggestion) =>
    //   suggestion.startsWith(value));

    setListOfLabourYearsFrom(makeLabourYearFromSuggestionsList());
    setShowLabourYearFromSuggestions(true);

  }

  const handleLabourYearFromInputOnFocus = () => {
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearTillInputValue && !birthYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);

    }
    setListOfLabourYearsFrom(makeLabourYearFromSuggestionsList());

    setShowLabourYearFromSuggestions(true);


  }

  const handleLabourYearFromInputOnBlur = () => {
    setTimeout(() => {
      setShowLabourYearFromSuggestions(false)
    }, 200);
  }

  const handleLabourYearFromInputOnSuggestionClick = (suggestion) => {
    setLabourYearFromInputValue(suggestion);
    setShowLabourYearFromSuggestions(false);

    let tempAllNames = [];

    filteredAllNames.map((person) => {
      if (person.beschaeftigt_von_Jahr) {

        if (Array.isArray(person.beschaeftigt_von_Jahr)) {
          person.beschaeftigt_von_Jahr.map((year) => {

            if (year >= suggestion) {
              tempAllNames.push(person);

            }
          })
        }

        else {
          if (person.beschaeftigt_von_Jahr >= suggestion) {
            tempAllNames.push(person)

          }
        }



      }
      else {
        tempAllNames.push(person);

      }




    })
    const uniqueArray = [...new Set(tempAllNames)];


    setFilteredAllNames(uniqueArray);
    setNumOfresults(filteredAllNames.length)
  }

  const handleLabourYearTillInputOnChange = (e) => {
    const value = e.target.value;
    setLabourYearTillInputValue(value);
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearFromInputValue && !labourYearFromInputValue && !birthYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    // const filtered = makeBirthYearFromSuggestionsList().filter((suggestion) =>
    //   suggestion.startsWith(value));

    setListOfLabourYearsTill(makeLabourYearTillSuggestionsList());
    setShowLabourYearTillSuggestions(true);

  }

  const handleLabourYearTillInputOnFocus = () => {
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearFromInputValue && !labourYearFromInputValue && !birthYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);

    }
    setListOfLabourYearsTill(makeLabourYearTillSuggestionsList());

    setShowLabourYearTillSuggestions(true);


  }

  const handleLabourYearTillInputOnBlur = () => {
    setTimeout(() => {
      setShowLabourYearTillSuggestions(false)
    }, 300);

  }

  const handleLabourYearTillInputOnSuggestionClick = (suggestion) => {
    setLabourYearTillInputValue(suggestion);
    // console.log(suggestion);

    setShowLabourYearTillSuggestions(false);

    let tempAllNames = [];

    filteredAllNames.map((person) => {
      if (person.beschaeftigt_bis_Jahr) {

        if (Array.isArray(person.beschaeftigt_bis_Jahr)) {
          person.beschaeftigt_bis_Jahr.map((year) => {

            if (year <= suggestion) {
              tempAllNames.push(person);

            }
          })
        }

        else {
          if (person.beschaeftigt_bis_Jahr <= suggestion) {
            tempAllNames.push(person)

          }
        }



      }
      else {
        tempAllNames.push(person);

      }




    })
    // console.log(tempAllNames);
    const uniqueArray = [...new Set(tempAllNames)];
    // console.log(uniqueArray.length);

    // console.log(uniqueArray);

    setFilteredAllNames(uniqueArray);
    setNumOfresults(filteredAllNames.length)

  }


  const makeNameSuggestionsList = useCallback(() => {

    // let names;
    if (!surNameInputValue && !landInputValue && !birthYearFromInputValue && !birthYearTillInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      // console.log(surNameInputValue);
      setFilteredAllNames(allNames);



      // names = filteredAllNames;
    }

    // else {
    //   names = filteredAllNames;
    // }

    let tempNameList = [];
    filteredAllNames.map((name) => {

      if (name.Vorname) {
        tempNameList.push(name.Vorname);
      }

      // console.log(name.Modified_Namen_andere_version);
      if (name.Modified_Namen_andere_version != '') {
        // console.log(name.Modified_Namen_andere_version);

        if (Array.isArray(name.Modified_Namen_andere_version)) {
          // console.log(name.Modified_Namen_andere_version);
          name.Modified_Namen_andere_version.map((nameversion) => {
            // console.log(nameversion);
            tempNameList.push(nameversion)

          })

        }
        else {
          // console.log(name.Modified_Namen_andere_version);

          tempNameList.push(name.Modified_Namen_andere_version)
        }
        // tempNameList.push(name.Modified_Namen_andere_version);
      }



    })
    // console.log(tempNameList);


    const uniqueArray = [...new Set(tempNameList.sort())];
    setListOfNames(uniqueArray);
    return uniqueArray
    // console.log(uniqueArray);

  }, [filteredAllNames])

  const makeSurnameSuggestionsList = useCallback(() => {
    // let surnames;

    if (!nameInputValue && !landInputValue && !birthYearFromInputValue && !birthYearTillInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      // console.log(surNameInputValue);

      setFilteredAllNames(allNames);
      // surnames = allNames;
    }

    // else {
    //   surnames = filteredAllNames;
    // }

    let tempSurnamesList = [];

    filteredAllNames.map((name) => {

      if (name.Nachname) {
        tempSurnamesList.push(name.Nachname);
      }

      // console.log(name.Modified_Namen_andere_version);
      if (name.Modified_Namen_andere_version != '') {
        // console.log(name.Modified_Namen_andere_version);

        if (Array.isArray(name.Modified_Namen_andere_version)) {
          // console.log(name.Modified_Namen_andere_version);
          name.Modified_Namen_andere_version.map((nameversion) => {
            // console.log(nameversion);
            tempSurnamesList.push(nameversion)

          })

        }
        else {
          // console.log(name.Modified_Namen_andere_version);

          tempSurnamesList.push(name.Modified_Namen_andere_version)
        }
        // tempNameList.push(name.Modified_Namen_andere_version);
      }



    })
    // console.log(tempNameList);


    const uniqueArray = [...new Set(tempSurnamesList.sort())];
    setListOfSurnames(uniqueArray);

    return uniqueArray







  }, [filteredAllNames]);


  const makeLandSuggestionsList = useCallback(() => {

    try {



      if (!nameInputValue && !surNameInputValue && !birthYearFromInputValue && !birthYearTillInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
        // console.log(surNameInputValue);

        setFilteredAllNames(allNames);
        // surnames = allNames;
      }

      let tempLandlist = [];


      filteredAllNames.map((name) => {
        if (name.Modified_Staat) {
          if (Array.isArray(name.Modified_Staat)) {
            name.Modified_Staat.map((i) => {
              tempLandlist.push(i);
            })
          }

          else {
            tempLandlist.push(name.Modified_Staat)
          }

        }



        // if (!landFilteredSuggestions) {
        //   setLandFilteredSuggestions(landList);
        // }




      });
      const uniqueLandArray = [...new Set(tempLandlist.sort())];

      setLandList(uniqueLandArray);

      return uniqueLandArray

    } catch (error) {

      console.error('the was an error ' + error);


    }




  }, [filteredAllNames])


  const makeLagerSuggestionsList = useCallback(() => {

    // let names;
    if (!surNameInputValue && !landInputValue && !birthYearFromInputValue && !birthYearTillInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !nameInputValue) {
      // console.log(surNameInputValue);
      setFilteredAllNames(allNames);



      // names = filteredAllNames;
    }
    let tempLagerlist = [];

    // console.log(numOfresults);


    filteredAllNames.map((name) => {
      if (name.Modified_Lager) {
        if (Array.isArray(name.Modified_Lager)) {

          name.Modified_Lager.map((i) => {
            tempLagerlist.push(i);
            // console.log(typeof i)
          })

        }
        else {
          tempLagerlist.push(name.Modified_Lager);

          // console.log(typeof name.Modified_Lager)
        }
      }

      // const uniqueArray = [...new Set(tempLagerlist)];

      // setLagerList(uniqueArray);


    });


    const uniqueArray = [...new Set(tempLagerlist.sort())];



    setLagerList(uniqueArray);
    return uniqueArray
  }, [filteredAllNames])


  const makeBirthYearFromSuggestionsList = useCallback(() => {
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearTillInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    let tempYearList = [];
    filteredAllNames.map((name) => {

      if (name.Geburts_Jahr) {
        if (Array.isArray(name.Geburts_Jahr)) {
          name.Geburts_Jahr.map((year) => {
            tempYearList.push(year);

          })
        }
        else {
          tempYearList.push(name.Geburts_Jahr)
        }
      }





    })
    // console.log(tempNameList);


    const uniqueArray = [...new Set(tempYearList.sort())];

    // console.log(uniqueArray);

    setListOfbirthYearsFrom(uniqueArray);
    return uniqueArray

  }, [filteredAllNames])



  const makeBirthYearTillSuggestionsList = () => {
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearFromInputValue && !labourYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    let tempYearList = [];
    filteredAllNames.map((name) => {

      if (name.Geburts_Jahr) {
        if (Array.isArray(name.Geburts_Jahr)) {
          name.Geburts_Jahr.map((year) => {
            tempYearList.push(year);

          })
        }
        else {
          tempYearList.push(name.Geburts_Jahr)
        }
      }





    })
    // console.log(tempNameList);


    const uniqueArray = [...new Set(tempYearList.sort())];
    setListOfbirthYearsTill(uniqueArray);
    return uniqueArray

  }
  const makeLabourYearFromSuggestionsList = () => {
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearTillInputValue && !birthYearFromInputValue && !labourYearTillInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    let tempYearList = [];
    filteredAllNames.map((name) => {

      if (name.beschaeftigt_von_Jahr) {
        if (Array.isArray(name.beschaeftigt_von_Jahr)) {
          name.beschaeftigt_von_Jahr.map((year) => {
            tempYearList.push(year);

          })
        }
        else {
          tempYearList.push(name.beschaeftigt_von_Jahr)
        }
      }





    })
    // console.log(tempNameList);


    const uniqueArray = [...new Set(tempYearList.sort())];
    setListOfLabourYearsFrom(uniqueArray);
    return uniqueArray

  }
  const makeLabourYearTillSuggestionsList = () => {
    if (!surNameInputValue && !landInputValue && !nameInputValue && !birthYearTillInputValue && !birthYearFromInputValue && !labourYearFromInputValue && !lagerInputValue) {
      setFilteredAllNames(allNames);
    }

    let tempYearList = [];
    filteredAllNames.map((name) => {

      if (name.beschaeftigt_bis_Jahr) {
        if (Array.isArray(name.beschaeftigt_bis_Jahr)) {
          name.beschaeftigt_bis_Jahr.map((year) => {
            tempYearList.push(year);

          })
        }
        else {
          tempYearList.push(name.beschaeftigt_bis_Jahr)
        }
      }





    })
    // console.log(tempNameList);


    const uniqueArray = [...new Set(tempYearList.sort())];
    setListOfLabourYearsTill(uniqueArray);
    return uniqueArray

  }

  const handleResetClick = () => {
    setFilteredAllNames(allNames);

    setNameInputValue('');
    setSurNameInputValue('');
    setLandInputValue('');
    setLagerInputValue('');
    setBirthYearFromInputValue('');
    setBirthYearTillInputValue('');
    setLabourYearFromInputValue('');
    setLabourYearTillInputValue('');


    setShowNameSuggestions(false);
    setShowSurnameSuggestions(false);
    setShowBirthYearFromSuggestions(false);
    setShowBirthYearTillSuggestions(false);
    setShowLandSuggestions(false);
    setShowLabourYearFromSuggestions(false);
    setShowLabourYearTillSuggestions(false);
    setShowLagerSuggestions(false);
    setResetClicked(true);

    // console.log(filteredAllNames);

  }







  const handleOnSubmit = (event) => {

    event.preventDefault();


    let tempFilterednames = [];
    if (landInputValue) {
      allNames.map((name) => {
        if (name.Modified_Staat) {
          if (Array.isArray(name.Modified_Staat)) {
            name.Modified_Staat.map((land) => {
              if (land === landInputValue) {
                tempFilterednames.push(name)

              }
            })
          }

          else {
            if (name.Modified_Staat === landInputValue) {
              tempFilterednames.push(name);
            }
          }
        }

      })

    }

    setFilteredAllNames(tempFilterednames);
    setNumOfresults(filteredAllNames.length)

    // console.log(filteredAllNames);

  }



  useEffect(() => {

    // setNumOfresults(filteredAllNames.length);
    if (!filteredAllNames) {
      setFilteredAllNames(allNames);
    }
    if (!numOfresults) {
      setNumOfresults(allNames.length)
    }

    if (resetClicked) {
      // console.log(filteredAllNames.length);
      setNumOfresults(filteredAllNames.length);
      // console.log('num of results ' + numOfresults);

      setResetClicked(false);



    }

    makeNameSuggestionsList();
    makeSurnameSuggestionsList();
    makeLandSuggestionsList();
    makeBirthYearFromSuggestionsList();
    makeBirthYearTillSuggestionsList();
    makeLabourYearFromSuggestionsList();
    makeLabourYearTillSuggestionsList();
    makeLagerSuggestionsList();

    // document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleClick);

    // Clean up the event listener on unmount
    return () => {
      // document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleClick);
    }



  }, [resetClicked]);


  return (



    <>
      <div className='searchBlock'>
        <form action="" onSubmit={handleOnSubmit}>

          <div className='searchForm'>

            <div className='serchfield_and_titel'>

              <div className='titel'>
                <p>Suche</p>
              </div>

              <div className='searchfield'>
                <input type="text" placeholder='Vorname'

                  value={nameInputValue}
                  onChange={handleNameInputOnChange}
                  onFocus={handleNameInputOnFocus}
                  onBlur={handleNameInputOnBlur}

                  autoComplete='none'




                />


                {/* {showNameSuggestions && nameFilteredSuggestions.length > 0 && (


                  <div className='seggestions_block' >
                    <ul
                      name='nameSuggestion'


                      className='suggestions'>
                      {nameFilteredSuggestions.map((suggestion, index) => (
                        <li
                          key={index}
                          name='landsuggestion'
                          onClick={() => handleNameSuggestionClick(suggestion)}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                          }}
                        >
                          {suggestion}
                        </li>
                      ))}
                    </ul>

                  </div>

                )} */}


                <input type="text" placeholder='Nachname'
                  value={surNameInputValue}
                  onChange={handleSurNameInputOnChange}
                  onFocus={handleSurnameInputOnFocus}
                  onBlur={handleSurnameInputOnBlur}
                  autoComplete='none'

                />


                <input type="text" placeholder='Land'

                  value={landInputValue}
                  // name='land'
                  onChange={handleLandInputChange}

                  onFocus={handleLandOnFocus}

                  onBlur={handleLandOnBlur}
                  autoComplete='none'

                />






                <input type="number" placeholder='Geburtsjahr von'

                  value={birthYearFromInputValue}
                  onChange={handleBirthYearFromInputOnChange}
                  onFocus={handleBirthYearFromInputOnFocus}
                  onBlur={handleBirthYearFromInputOnBlur}
                  autoComplete='none'


                />
                <input type="number" placeholder='Geburtsjahr bis'

                  value={birthYearTillInputValue}
                  onChange={handleBirthYearTillInputOnChange}
                  onFocus={handleBirthYearTillInputOnFocus}
                  onBlur={handleBirthYearTillInputOnBlur}
                  autoComplete='none'


                />
                <input type="number" placeholder='Beschäftigung von (Jahr)'

                  value={labourYearFromInputValue}

                  onChange={handleLabourYearFromInputOnChange}
                  onFocus={handleLabourYearFromInputOnFocus}
                  onBlur={handleLabourYearFromInputOnBlur}
                  autoComplete='none'


                />
                <input type="number" placeholder='Beschäftigung bis (Jahr)'
                  value={labourYearTillInputValue}
                  onChange={handleLabourYearTillInputOnChange}
                  onFocus={handleLabourYearTillInputOnFocus}
                  onBlur={handleLabourYearTillInputOnBlur}
                  autoComplete='none'

                />





                <input
                  type="text"
                  placeholder='Lager'
                  value={lagerInputValue}
                  onChange={handleLagerInputOnChange}
                  onFocus={handleLagerInputFocus}
                  onBlur={handleLagerOnBlur}
                  autoComplete='none'

                />

              </div>

            </div>

            {showNameSuggestions && nameFilteredSuggestions.length > 0 && (


              <div className='seggestions_block' >
                <ul
                  name='nameSuggestion'


                  className='suggestions'>
                  {nameFilteredSuggestions.map((suggestion, index) => (
                    <li
                      key={index}
                      name='landsuggestion'
                      onClick={() => handleNameSuggestionClick(suggestion)}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                      }}
                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>

              </div>

            )}


            {showSurnameSuggestions && surnameFilteredSuggestions.length > 0 && (


              <div className='seggestions_block' >
                <ul


                  name='nameSuggestion'


                  className='suggestions'>
                  {surnameFilteredSuggestions.map((suggestion, index) => (
                    <li
                      key={index}
                      name='landsuggestion'
                      onClick={() => handlesurnameSuggestionClick(suggestion)}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                      }}
                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>

              </div>

            )}

            {showLandSuggestions && landFilteredSuggestions.length > 0 && (


              <div className='suggestions_block' >
                <ul


                  name='landSuggestion'


                  className='suggestions'>
                  {landFilteredSuggestions.map((suggestion, index) => (
                    <li
                      key={index}
                      name='landsuggestion'
                      onClick={() => handleLandSuggestionClick(suggestion)}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                      }}
                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>

              </div>

            )}

            {showBirthYearFromSuggestions && listOfbirthYearsFrom.length > 0 && (
              <div className='seggestions_block'>
                <ul className='suggestions' >
                  {listOfbirthYearsFrom.map((suggestion, index) => (
                    <li
                      key={index}
                      onClick={() => handleBirthYearFromInputOnSuggestionClick(suggestion)}

                      style={{
                        padding: "8px",
                        cursor: "pointer",
                      }}


                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>

              </div>

            )}

            {showBirthYearTillSuggestions && listOfbirthYearsTill.length > 0 && (
              <div className='seggestions_block'>
                <ul className='suggestions' >
                  {listOfbirthYearsTill.map((suggestion, index) => (
                    <li
                      key={index}
                      onClick={() => handleBirthYearTillInputOnSuggestionClick(suggestion)}

                      style={{
                        padding: "8px",
                        cursor: "pointer",
                      }}


                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>

              </div>

            )}

            {showLabourYearFromSuggestions && listOfLabourYearsFrom.length > 0 && (
              <div className='seggestions_block'>
                <ul className='suggestions' >
                  {listOfLabourYearsFrom.map((suggestion, index) => (
                    <li
                      key={index}
                      onClick={() => handleLabourYearFromInputOnSuggestionClick(suggestion)}

                      style={{
                        padding: "8px",
                        cursor: "pointer",
                      }}


                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>

              </div>

            )}

            {showLabourYearTillSuggestions && listOfLabourYearsTill.length > 0 && (
              <div className='seggestions_block'>
                <ul className='suggestions' >
                  {listOfLabourYearsTill.map((suggestion, index) => (
                    <li
                      key={index}
                      onClick={() => handleLabourYearTillInputOnSuggestionClick(suggestion)}

                      style={{
                        padding: "8px",
                        cursor: "pointer",
                      }}


                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>

              </div>

            )}

            {showLagerSuggestions && LagerfilteredSuggestions.length > 0 && (
              <div className='seggestions_block'>
                <ul className='suggestions' >
                  {LagerfilteredSuggestions.map((suggestion, index) => (
                    <li
                      key={index}
                      onClick={() => handleLagerSuggestionClick(suggestion)}

                      style={{
                        padding: "8px",
                        cursor: "pointer",
                      }}

                      name={suggestion}
                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>

              </div>

            )}






            <div className='button_and_numberOfResults'>

              <div className='numberOfResults'>
                <p > {getNumOfresults()} ergebnisse werden gezeigt</p>
              </div>
              <div className='button'>
                <button onClick={handleResetClick}><p>Zurücksetzen</p></button>
              </div>
              {/* <div className='button'>
                <button type='submit'> <p>Anwenden</p></button>
              </div> */}

            </div>







          </div>

        </form>






      </div>

      {filteredAllNames && <NameBox allNames={getFilteredAllNames()}></NameBox>}

    </>
  )
}

export default Search